import { render, staticRenderFns } from "./MultiviewerNew.vue?vue&type=template&id=f49d9a70&scoped=true"
import script from "./MultiviewerNew.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiviewerNew.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MultiviewerNew.vue?vue&type=style&index=0&id=f49d9a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49d9a70",
  null
  
)

export default component.exports